// export function aesDecrypt(data: base64) {
//   const dataAscii = cryptico.b64to256(data)
//   const encryptedBlocks = cryptico.string2bytes(dataAscii)
//   const exkey = global.aesKey.slice(0)
//   aes.ExpandKey(exkey)
//   aes.Decrypt(encryptedBlocks, exkey)
//   return cryptico.bytes2string(encryptedBlocks)
// }

import type { AESKey } from '@daotl/cryptico'
import { aes, cryptico, RSAKey } from '@daotl/cryptico'

export function aesEncrypt(data: string, aesKey: AESKey): string {
  const exkey = aesKey.slice(0)
  aes.ExpandKey(exkey)
  let blocks = cryptico.string2bytes(data)
  blocks = cryptico.pad16(blocks)
  aes.Encrypt(blocks, exkey)
  let ciphertext = cryptico.bytes2string(blocks)
  ciphertext = cryptico.b256to64(ciphertext)
  return ciphertext
}

export function rsaEncrypt(
  data: string,
  rsaKey: { n: string; e1: string },
): string {
  const rsa = new RSAKey()
  rsa.setPublic(rsaKey.n, rsaKey.e1)
  return rsa.encrypt(data)
}

export function loadRSAKey(rsaKey: string): RSAKey {
  const str = cryptico.b64to256(rsaKey)
  const strs = str.split(',')
  const key = new RSAKey()
  key.setPrivate(strs[0], strs[0], strs[0])
  return key
}

// function testRSA() {
//   pubKey = loadRSAKey(global.privKey)
//   reqContent = {}
//   reqContent.action = 'main'
//   reqContent.arg = '[{"score":20},{"score":20}]'
//   reqContent.contractID = 'abc'
//   eReq = encryptReq(reqContent, pubKey)
//   url =
//     'http://localhost:8080/SCIDE/SCManager?action=executeContractEncrypted&contractRequest=' +
//     encodeURIComponent(JSON.stringify(eReq))
// }

export function encryptReq(
  reqContent: { contractID: string },
  pubKey: RSAKey,
): {
  action: string | null
  contractID: string
  arg: string
  requester: string
} {
  const aes = {
    key: cryptico.generateAESKey(),
  }
  const aesObj = JSON.stringify(aes)
  const { contractID } = reqContent
  const reqContentNoId = { ...reqContent, contractID: undefined }
  const encrypedReq = {
    action: pubKey.decrypt(aesObj),
    contractID,
    arg: aesEncrypt(JSON.stringify(reqContentNoId), aes.key),
    requester: cryptico.b256to64(
      `${pubKey.n.toString(16)},${pubKey.e.toString(16)},0`,
    ),
  }
  return encrypedReq
}
